import type { MouseEvent } from 'react'
import type { MotnItem } from '~/entities/motn'
import type { ViewRow } from '../../model/components/index.h'

import { CardAnimations } from "/app/libraries/arcana/src/blocks/Cards/index.ts"
import { TopVodSimpleCard, VodSimpleCard } from "/app/libraries/arcana/src/blocks/Cards/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useCallback, useMemo } from 'react'
import { buildMotnLink } from '~/entities/motn'
import * as pinLockFeature from '~/features/pin-lock'
import {
  VodCardHorizontalCoversMap,
  VodCardVerticalCoversMap,
} from '~/shared/ui/components/cardCovers'
import { getCardContentPadding } from '../lib/style'

export const MotnCard = ({
  row,
  item,
  idx,
}: {
  row: ViewRow
  item: MotnItem
  idx: number
}) => {
  const { imageUrl, imageHorizontalUrl, name } = item

  const {
    appearance: {
      style: { posterSize, posterOrientation, topContent },
    },
  } = row

  const { intercept } = useUnit({
    intercept: pinLockFeature.intercept,
  })

  const handleClick = useCallback(
    (event: MouseEvent<Element>) => {
      event.preventDefault()
      event.stopPropagation()
      intercept({
        locked: false,
        name,
        '<event>': event,
      })
    },
    [intercept, name]
  )

  const contentPadding = getCardContentPadding(posterSize)

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? imageHorizontalUrl : imageUrl
  const covers =
    posterOrientation === 'HORIZONTAL'
      ? VodCardHorizontalCoversMap
      : VodCardVerticalCoversMap

  const Card = topContent ? TopVodSimpleCard : VodSimpleCard
  const topNumber = idx + 1

  const link = useMemo(
    () => buildMotnLink(item, { routeName: row?.appearance?.title }),
    [item, row]
  )

  return (
    <a href={link}>
      <Card
        onClick={handleClick}
        childrenTransition={CardAnimations.FadeIn}
        lazyImage={false}
        type={posterOrientation}
        posterUrl={posterUrl}
        paid={false}
        rented={false}
        locked={false}
        title={name}
        contentPadding={contentPadding}
        covers={covers}
        verticalVideo={false}
        topNumber={topNumber}
        isExternalContent
      />
    </a>
  )
}
